<div class="row">
    <div class="col-5 col-sm-6 col-md-8 col-lg-9 title">{{ 'qcloud-reservation' | translate }}</div>
    <div class="col-7 col-sm-6 col-md-4 col-lg-3">
        <div class="row justify-content-end">
            <a class="col-4 col-sm-3" role="button" (click)="changeLanguage('pl')">
                <img class="img-fluid rounded-circle pointer" src="assets/images/pl.svg" 
                    alt="PL" [ngClass]="{'selected': checkLanguage('pl')}">
            </a>
            <a class="col-4 col-sm-3" role="button" (click)="changeLanguage('en')">
                <img class="img-fluid rounded-circle pointer" src="assets/images/gb.svg" 
                    alt="EN" [ngClass]="{'selected': checkLanguage('en')}">
            </a>
        </div>
    </div>
</div>
